<template>
  <div>
    <div class="row no-gutters">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Master Kurikulum'">
          <template v-slot:toolbar>
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')"
              dataTitleTooltip="Tambah Data" />
          </template>
          <template v-slot:body>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="dataKurikulum" :search="search" class="custom-header">
                <template v-slot:item.no="{ item, index }">
                  {{ item.no }}
                </template>
                <template v-slot:item.file="{ item }">
                  <span @click="downloadItem(item.file)" class="cursor-hand">{{ item.file }}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <span v-if="item.status === true" class="mr-1">Aktif</span>
                  <span v-else class="mr-1">Tidak Aktif</span>
                </template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit', item)"
                    dataTitleTooltip="Edit" />
                  <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.key)"
                    dataTitleTooltip="Hapus" />
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>

        <b-modal @ok="onSubmit" ok-title="Simpan" no-enforce-focus ok-variant="primary" cancel-title="Batal"
          cancel-variant="danger" id="modal" :title="`${statusModal} Kurikulum`">
          <b-form>
            <b-form-group label="Kurikulum :">
              <b-form-input type="text" required v-model="request.curriculum"
                placeholder="Masukkan Kurikulum"></b-form-input>
            </b-form-group>
            <b-form-group label="File :">
              <!-- <b-form-file v-model="request.file" ref="fileInput" class="mt-3" accept="application/pdf" plain @change="handleFileChange"></b-form-file> -->
              <input type="file" ref="file" @change="onFileUpload" accept="application/pdf" />
              <p v-show="statusModal === 'Edit'" >File Sebelumnya: {{ request.filebefore }} &nbsp; <ButtonComponent :name="'csv'" @click.native="downloadItem(request.filebefore)" :dataTitleTooltip="'View File'"></ButtonComponent> </p>
            </b-form-group>
            <b-form-group label="Status :">
              <Select2 v-model="request.status" :options="statusE"
                :settings="{ settingOption: value, multiple: false, width: '100%' }" :placeholder="`Pilih Status`" />
            </b-form-group>
          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .cursor-hand{
    cursor: pointer;
    color: blue;
    text-decoration: underline;
  }
</style>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Select2 from 'v-select2-component';
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"
import axios from "axios";

export default {
  data() {
    return {
      statusE: [
        { id: true, text: "Aktif" },
        { id: false, text: "Tidak Aktif" }
      ],
      statusModal: '',
      dataLogin: JSON.parse(localStorage.getItem('dataLogin')),
      dataKurikulum: [],
      request: {
        key: null,
        curriculum: null,
        file: null,
        status: null
      },
      search: "",
      filebefore: null,
      headers: [
        { text: "No", value: "no", align: "center", sortable: false },
        { text: "Kurikulum", value: "curriculum", align: "center" },
        { text: "File", value: "file",  align: "center" },
        { text: "Status", value: "status", align: "center" },
        { text: "Aksi", value: "action", align: "center", sortable: false }
      ],
    };
  },
  components: {
    KTCodePreview,
    ButtonComponent,
    Select2
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Master" },
      { title: "Kurikulum" }
    ]);

    this.getData()
  },
  methods: {

    openModal(status, itemData = null) {
      this.statusModal = status
      // reset form
      this.request = {
        key: null,
        curriculum: null,
        file: null,
        status: null,
      }
      if (status == 'Edit') {
        this.request.key = itemData.key
        this.request.curriculum = itemData.curriculum
        this.request.file = itemData.file
        this.request.filebefore = itemData.file
        this.request.status = itemData.status
      }
    },

    async getData() {
      try {
        const result = await axios.get(`master/curriculums`)
        if (this.dataKurikulum.length > 0) {
          this.dataKurikulum = [];
        }
        result.data.data.map((kurikulum, index) =>  {
          let obj = {
            no: index+1,
            key: kurikulum.key,
            curriculum: kurikulum.curriculum,
            file: kurikulum.file,
            status: kurikulum.status,
          }
          // if (kurikulum.status == true) {
            this.filebefore = kurikulum.file;
            this.dataKurikulum.push(obj);
          // }
        })
        // this.dataKurikulum = result.data.data;
      } catch (err) {
          this.$swal(`Failed`);
      } // finally {
      //   // check if first load / not refresh
      //   if (!refresh) {
      //     // inisiasi datatable
      //     // this.$nextTick(() => {
      //     //   this.initDt()
      //     // })
      //   }
      // }
    },

  //   downloadItem ({ url, label }) {
  //   Axios.get(url, { responseType: 'blob' })
  //     .then(response => {
  //       const blob = new Blob([response.data], { type: 'application/pdf' })
  //       const link = document.createElement('a')
  //       link.href = URL.createObjectURL(blob)
  //       link.download = label
  //       link.click()
  //       URL.revokeObjectURL(link.href)
  //     }).catch()
  // },

    async onSubmit() {
      const form = this.request

      if (form.key === null) {
        // store
        this.store(form)
      } else {
        // update
        // const file = event.target.files[0]; // Mendapatkan file yang dipilih oleh pengguna
        // this.request.file = file.name; // Menyimpan nama file pada data properti
        this.update(form)
      }
    },

    async store(form) {
      try {
        const file = form.file;
        if (file.type != "application/pdf") {
          this.$swal(`File Harus .pdf`);
        } else {
          const formData = new FormData()
          formData.append("curriculum", form.curriculum);
          formData.append("status", form.status);
          formData.append('file', form.file);

          const kurikulum = this.dataKurikulum.filter(kur => kur.curriculum.toUpperCase() == form.curriculum.toUpperCase());
          if (kurikulum.length > 0) {
            this.$swal('Data already exist');
          }else{
            const response = await axios.post('master/curriculum', formData)
            // if(form.status) {
            //   let data_aktif = this.dataKurikulum.find(s => s.status == true);
            //   if(data_aktif) {
            //     const formData = new FormData()
            //     formData.append("curriculum", data_aktif.curriculum);
            //     formData.append("status", false);
            //     formData.append('file', data_aktif.file);
                
            //     await axios.post(`master/curriculum/${data_aktif.key}`, formData);
            //   }
            // }
            this.refreshData(response, 'Store')
          }
        }
      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    async update(form) {
      try {
        const file = form.file;
        let data = this.dataKurikulum.find(s => s.key == form.key);
        if (data.file == form.file) {
          const kurikulum = this.dataKurikulum.filter(kur => kur.curriculum.toUpperCase() == form.curriculum.toUpperCase());
          if (kurikulum.length > 1) {
            this.$swal('Data already exist');
          }else{
            const formData = new FormData()
            formData.append("curriculum", form.curriculum);
            formData.append("status", form.status);
            formData.append('file', data.file);
            const result = await axios.post(`master/curriculum/${form.key}`, formData);
            // if(form.status) {
            //   let data_aktif = this.dataKurikulum.find(s => s.status == true);
            //   if(data_aktif) {
            //     const formData = new FormData()
            //     formData.append("curriculum", data_aktif.curriculum);
            //     formData.append("status", false);
            //     formData.append('file', data_aktif.file);
                
            //     await axios.post(`master/curriculum/${data_aktif.key}`, formData);
            //   }
            // }
            this.refreshData(result, 'Update');
          }
        }else{
          const formData = new FormData()
          formData.append("curriculum", form.curriculum);
          formData.append("status", form.status);
          formData.append('file', form.file);
          if (file.type != "application/pdf") {
            this.$swal(`File Harus .pdf`);
          } else {
            const result = await axios.post(`master/curriculum/${form.key}`, formData);
            if(form.status) {
              let data_aktif = this.dataKurikulum.find(s => s.status == true);
              if(data_aktif) {
                const formData = new FormData()
                formData.append("curriculum", data_aktif.curriculum);
                formData.append("status", false);
                formData.append('file', data_aktif.file);
                
                await axios.post(`master/curriculum/${data_aktif.key}`, formData);
              }
            }
            this.refreshData(result, 'Update');
          }
        }
      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    onFileUpload() {
      this.request.file = this.$refs.file.files[0];
    },

    refreshData(result, alert) {
      if (result.data.meta.code == 200) {
        this.$swal(`Success ${alert} Data`);
        this.getData()
      } else {
          this.$swal(`Failed`);
      }
    },

    
    openFileInput() {
      this.$refs.fileInput.click(); // Membuka jendela pemilihan file saat tombol "Edit" diklik
    },
    handleFileChange(event) {
      const file = event.target.files[0]; // Mendapatkan file yang dipilih oleh pengguna
      this.request.file = file.name; // Menyimpan nama file pada data properti
    },

    async deleteData(key) {
      try {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this item!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then(async (result) => {
          if (result.value) {
            // User confirmed, so delete the item
            const result = await axios.delete(`master/curriculum/${key}`)
            this.refreshData(result, 'Delete')
          } else {
            // User canceled, so do nothing
          }
        })
      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    downloadItem(label) {
      const externalRouteUrl = this.$endpoint + 'uploads/dokumen_kurikulum/' + label;
      window.open(externalRouteUrl, '_blank');
    },
  },
  computed: {
    config() {
      let dataConfig = {
        headers: { Authorization: `Bearer ${this.dataLogin.access_token}`, 'Content-Type': 'application/json' }
      }
      return dataConfig
    }
  }
}
</script>